import { Link, useNavigate } from "react-router-dom";
import { renderStatus } from "../../../../Utils/CommonUtils";
import rootReducer from "../../../../store";
import { Button } from "react-bootstrap";
import { setSelectedUser } from "../../../../slices/header/headerSlice";
import { setAgSwitch } from "../../../../slices/ag/affinityGroup/affinityGroupSlice";

const useAffinityGroupColumns = () => {
  const navigate = useNavigate();
  const affinityGroupColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/ag/ag/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 100,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Created Date",
      accessorKey: "created_date",
      // cell: (props) => {
      //   {props?.getValue() ? props?.getValue() : "-"}
      // },
      size: 200,
    },
    {
      header: "Category",
      accessorKey: "buss_category",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Contact Person",
      accessorKey: "pri_contact_name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Contact Number",
      accessorKey: "pri_contact_number",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: (props) => (
        <div>
          <Button
            className="primary-outline"
            onClick={() => {
              const selectedData = {
                name: props.row.original.name,
                providerName: props.row.original.entitytype,
                buss_category: props.row.original.buss_category,
                code: props.row.original.code,
                entityid: props.row.original.entityid,
                entitytype: props.row.original.entitytype,
                organizationid: props.row.original.organizationid,
                owner_id: props.row.original.owner_id,
                organization_type: props.row.original.organization_type,
                agsa_icon_media_url: props.row.original.agsa_icon_media_url,
              };
              rootReducer.dispatch(setSelectedUser(selectedData));
              rootReducer.dispatch(setAgSwitch(props?.row?.original?.entityid));
              navigate("/hub/information");
            }}
          >
            Manage
          </Button>
        </div>
      ),
      meta: { align: "center" },
      size: 150,
    },
  ];

  return { affinityGroupColumns };
};
export default useAffinityGroupColumns;
